import React, { useEffect, useState } from "react";
import "./../login.css";
import logo from "./../../../assets/images/LogoTransparent.png";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import jwt_decode from "jwt-decode";
import { useNavigate } from "react-router-dom";
import loadingGif from "./../../../assets/images/loading.gif";
import { useDispatch, useSelector } from "react-redux";
import { saveSpecifications } from "./../../../reduxadmin/Actions/index";
import ReloadAllTabs from "./../Reload";
import FoodDeliveryLoader from "../../components/LoadingView/FoodDeliveryLoder";

const fileTypes = ["JPG", "PNG", "GIF"];

const LoginForCourier = () => {
  const dispatch = useDispatch();
  const totalNotification = useSelector(
    (state) => state.testRedux.specification,
  );

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [passwordNotFound, setPasswordNotFound] = useState(false);

  const apiAddress = process.env.REACT_APP_SECRET;

  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState("true");

  const [isTempLoading, setIsTempLoading] = useState("false");

  const ProceedLoginusiingAPI = (e) => {
    e.preventDefault();
    var loading = "true";
    setIsTempLoading(loading);
    setIsLoading([]);
    console.log("isLoading: " + isLoading);
    console.log("apiAddress: " + apiAddress);

    var url =
      apiAddress +
      "/api/AdminLogin/loginforcourier?userName=" +
      username +
      "&password=" +
      password;
    axios({
      method: "post",
      url: url,
    })
      .then(function (response) {
        console.log(response);
        console.log("Data: " + response.data.token);
        localStorage.setItem("gotasteadmintoken", response.data.token);
        // In the tab where storage changes
        localStorage.setItem("myKey", "myValue");

        // Broadcast the change to other tabs
        const broadcastChannel = new BroadcastChannel("storage_change_channel");
        broadcastChannel.postMessage("storage_changed");

        window.dispatchEvent(new Event("storage"));
        dispatch(saveSpecifications(response.data.token));
        let decoded = null;
        if (response.data.token != null) {
          try {
            decoded = jwt_decode(response.data.token);
            console.log(decoded);
          } catch (error) {}
          if (decoded != null || decoded != undefined) {
            // if (decoded.UserRole == "KycSubmitter") {
            //     navigate("/kyc-form?id=" + decoded.kycId);
            // }
            // else if (decoded.UserRole == "Admin") {
            //     navigate("/admin-dashboard");
            // }
            // else {
            //     navigate("/");
            //     // window.location.href = "/";
            // }
          }
        }
      })
      .catch(function (error) {
        loading = "false";
        setIsTempLoading(loading);
        setIsLoading([]);
        console.log(error);
        if (error.response.status == 404) {
          console.log(
            "error.response.data.status: " + error.response.data.status,
          );
          if (error.response.data.status == "Password not found") {
            setPasswordNotFound(true);
          } else if (error.response.data.status == "Not activated") {
            toast.error("Not Activated", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          } else if (error.response.data.status == "User type not valid") {
            toast.error("Not valid user for admin panel", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          } else if (error.response.data.status == "Email not verified") {
            toast.error("Please verify your email", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          } else if (
            error.response.data.status ==
            "Admin cancel or deactivated your account"
          ) {
            toast.error("Admin cancel or deactivated your account", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          } else if (
            error.response.data.status ==
            "Your restaurant account is deactivated"
          ) {
            toast.error(
              "Your restaurant account is deactivated! Please contact admin",
              {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              },
            );
          } else {
            toast.error(error.response.data.status, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          }
        }
        if (error.response.status == 401) {
          toast.error("Account not found", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
      });
  };

  useEffect(() => {
    setIsLoading(isTempLoading);
    // var token = localStorage.getItem('gotasteadmintoken');
    // if (token) {
    //     window.localStorage.href = '/';
    // }
  }, [isLoading]);

  useEffect(() => {
    // var token = localStorage.getItem('gotasteadmintoken');
    // if (token) {
    //     var decodedData = jwt_decode(token)
    //     console.log(decodedData)
    //     if (decodedData.UserRole == "Admin") {
    //         navigate("/admin-dashboard")
    //     }
    //     else {
    //         navigate("/")
    //     }
    // }
  }, []);

  return (
    <div style={{ height: "100vh" }}>
      <ToastContainer />
      {isLoading == "true" ? (
        <div
          className={`d-flex align-items-center justify-content-center h-100 `}
        >
          <FoodDeliveryLoader/>
        </div>
      ) : (
        <div>
          <div className="Loginbanner"></div>
          <div className="loginCard">
            <form onSubmit={ProceedLoginusiingAPI}>
              <div className="row">
                <div className="col-12 d-flex justify-content-center">
                  <img src={logo} alt="" style={{ width: "5rem" }} />
                </div>
                <div className="col-12 mt-3 d-flex justify-content-center">
                  <h5>Welcome To Check Your Menu</h5>
                </div>
                <div className="col-12 mt-3">
                  <input
                    type="text"
                    className="form-control login-info"
                    value={username}
                    placeholder="Email Address"
                    onChange={(event) => {
                      setUsername(event.target.value);
                    }}
                  />
                </div>
                <div className="col-12 mt-3">
                  <input
                    type="password"
                    className="form-control login-info"
                    value={password}
                    placeholder="Password"
                    onChange={(event) => {
                      setPassword(event.target.value);
                    }}
                  />
                  <span
                    className={`${passwordNotFound ? "" : "d-none"}`}
                    style={{ color: "red", fontSize: ".8rem" }}
                  >
                    {" "}
                    Password not matched *
                  </span>
                </div>

                <div className="col-12 mt-3 d-flex justify-content-center">
                  <button
                    className="btn btn-success"
                    style={{ width: "100%" }}
                    type="submit"
                  >
                    Login
                  </button>
                </div>
                <div className="col-12 mt-3 d-flex justify-content-center">
                  <span>Don't have any account? </span>
                </div>
                <div className="col-12  d-flex justify-content-center">
                  <a href={window.location.origin + "/registrationforcourier"}>
                    Register Now
                  </a>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default LoginForCourier;
